import { Card, CardContent, CardTitle } from "../ui/Card";
import SpaceshipImage from "../../Assets/Images/Spaceship-transformed.avif";
import ReachImage from "../../Assets/Images/Reach-transformed.avif";
import BagImage from "../../Assets/Images/TheBag-transformed.avif";
import { useTranslation } from "react-i18next";

export default function SecondSection() {
  const { t } = useTranslation();
  return (
    <section className="w-full py-12 md:py-24 lg:py-32 rounded-t-0 rounded-b-[20px] bg-gradient-to-b from-grey-100 via-red-100 to-red-400">
      <div className="container px-4 md:px-6">
        <h2 className="text-2xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-center mb-8 bg-clip-text text-transparent bg-gradient-to-r from-red-600 to-orange-600">
          {t("about.differentTitle")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {renderCard(
            t("about.diff1Title"),
            t("about.diff1Desc")
          )}
          {renderCard(
            t("about.diff2Title"),
            t("about.diff2Desc")
          )}
          {renderCard(
            t("about.diff3Title"),
            t("about.diff3Desc")
          )}
        </div>
      </div>
    </section>
  );
}

const renderCard = (title, description) => (
  <Card className="bg-white/80 backdrop-blur-sm hover:shadow-2xl transition-shadow transform duration-300 rounded-lg p-4 border-2 border-transparent hover:border-red-500">
    <CardContent className="p-6 flex flex-col items-center text-center space-y-4">
      <h3 className="text-xl font-bold text-gray-800 transition-transform transform">
        <span dangerouslySetInnerHTML={{ __html: title }} />
      </h3>
      <div className="mt-6 h-1 w-full bg-gradient-to-r from-red-500 to-orange-600"></div>
      <p className="text-gray-600 text-lg">
        <span dangerouslySetInnerHTML={{ __html: description }} />
      </p>
    </CardContent>
  </Card>
);
